<section class="dashboard-detail">
  <div class="detail-card">
    <div class="detail-header">
      <div>
        <h2>Pacientes en espera</h2>
      </div>
    </div>

    @if (pendientesOrdenados.length === 0) {
      <div class="sin-datos">
        <mat-icon class="material-symbols-outlined"> patient_list </mat-icon>

        <h2>No hay pacientes en espera</h2>
      </div>
    } @else {
      <div class="detail-body">
        <!-- ENCABEZADOS -->
        <div class="patient-header">
          <span>Prioridad</span>
          <span>Paciente</span>
          <span>Hora</span>
          <span>Signos</span>
          <span>Consulta</span>
          <span>Cancelar</span>
        </div>

        @for (p of pendientesOrdenados; track p.id) {
          <div class="patient">
            <span class="prioridad" [ngClass]="p.prioridad" data-label="Prioridad"></span>

            <strong data-label="Paciente">
              {{ p.paciente?.nombre }}
              {{ p.paciente?.apellido }}
              {{ p.paciente?.segundoApellido }}
            </strong>

            <span class="hora" data-label="Hora">
              {{ p.horaLlegada | date: 'HH:mm' }}
            </span>

            <button
              class="patient-action"
              mat-icon-button
              color="accent"
              (click)="abrirGragicaSignosVitales(p)"
              matTooltip="Ver historial de signos vitales"
              aria-label="Ver historial de signos vitales"
            >
              <mat-icon>monitor_heart</mat-icon>
            </button>

            <button
              class="patient-action"
              mat-icon-button
              color="accent"
              (click)="abrirConsulta(p)"
              matTooltip="Enviar a consulta"
              aria-label="Enviar a consulta"
            >
              <mat-icon>send</mat-icon>
            </button>

            <button
              class="patient-action"
              mat-icon-button
              color="warn"
              (click)="cancelarConsulta(p)"
              matTooltip="Cancelar consulta"
              aria-label="Cancelar consulta"
            >
              <mat-icon>cancel_schedule_send</mat-icon>
            </button>
          </div>
        }
      </div>

      <div class="detail-footer">
        <button (click)="mostrarTodos()">Ver todos ({{ totalPendientes }})</button>
      </div>
    }
  </div>
</section>
